import IconLabelCarC from '@adv-mt/mt-svg-icons/lib/LabelCarC.js'
import IconLabelCarEco from '@adv-mt/mt-svg-icons/lib/LabelCarEco.js'
import IconLabelCarZero from '@adv-mt/mt-svg-icons/lib/LabelCarZeroEmissions'

// AtomIcon defaults to design=FILLED which applies `fill: inherit !important`
// on every SVG path, overriding the hardcoded fills of these multicolor
// eco-label icons. FILLED and OUTLINE are the only designs with CSS rules, so
// any other value leaves the original fills intact. Size is still injected by
// FilterItemBasic when calling the icon function.
const withMulticolorDesign = Icon => props => <Icon {...props} design="multicolor" />

export const fuelTypesIcons = {
  1: withMulticolorDesign(IconLabelCarC),
  2: withMulticolorDesign(IconLabelCarC),
  3: withMulticolorDesign(IconLabelCarZero),
  4: withMulticolorDesign(IconLabelCarEco),
  5: withMulticolorDesign(IconLabelCarZero),
  6: withMulticolorDesign(IconLabelCarEco),
  7: withMulticolorDesign(IconLabelCarEco)
}
